var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-content",style:({'margin-top':_vm.marginTop})},[_c('img',{staticClass:"empty-content-image",attrs:{"src":_vm.setSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }